import { NgModule } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule, provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { CoreEffects } from '@next/core-lib';
import { provideAgrAdvisorRelationshipsSelector } from '@next/core-lib/advisor-relationships-selector';
import { coreRoutes, provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import {
  AgrChipsFilterModule,
  AgrFilterModule,
  AgrLocationSummaryModule,
  AgrNotificationEmptyModule,
  AgrPageModule,
  AgrPrimaryActionModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { provideAgrElasticApi } from '@next/core-lib/elastic';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { SiteEffects } from '@next/core-lib/site';
import { AgrTableModule } from '@next/core-lib/table';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';

import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';

import { AppComponent } from './app.component';
import { provideAppInitializers } from './app.initializer';
import { appRoutes } from './app.routes';
import { DashboardModule } from './dashboard/dashboard.module';
import { MyAdvertisementsModule } from './my-advertisements/my-advertisements.module';
import { MyAdvertisementsEffects } from './my-advertisements/store/effects/my-advertisements.effects';
import { OfferModule } from './offer/offer.module';
import { OfferEffects } from './offer/store/effects/offer.effects';
import { RequestModule } from './request/request.module';
import { RequestEffects } from './request/store/effects/request.effects';
import { SharedModule } from './shared/shared.module';
import { AppEffects } from './store/effects';
import { manureReducer } from './store/reducer';

@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule,
    SharedModule,
    DashboardModule,
    MyAdvertisementsModule,
    RequestModule,
    OfferModule,
    MatDialogModule,
    AgrDialogModule,
    AgrTableModule,
    AgrChipsFilterModule,
    AgrFilterModule,
    MatTabsModule,
    AgrLocationSummaryModule,
    AgrNotificationEmptyModule,
    AgrPageModule,
    AgrPrimaryActionModule,
    AgrWrapperSiteSidenavModule,
  ],
  providers: [
    provideRouter([...appRoutes, ...coreRoutes], withEnabledBlockingInitialNavigation()),
    provideAppInitializers(),
    provideAgrAdvisorRelationshipsSelector(),
    provideAgrElasticApi(),
    { provide: MatDialogRef, useValue: {} },
    provideStore(
      { app: manureReducer },
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideEffects([
      CoreEffects,
      I18nEffects,
      I18nBrowserEffects,
      SiteEffects,
      NavigationEffects,
      AppEffects,
      OfferEffects,
      RequestEffects,
      MyAdvertisementsEffects,
    ]),
  ],
})
export class AppModule {}
